<div class="flex min-h-[100dvh] w-full flex-col bg-gradient-to-b from-[#F4F4F7] to-[#EAE5FB] text-black">
  <app-desktop-header active="my-data" (sectionSelect)="onHeaderSectionSelect()"></app-desktop-header>

  <!-- Top navigation (mobile) - Figma node 82:34147 -->
  <div class="sticky top-0 z-10 flex h-11 items-center justify-between bg-white pl-[18px] pr-4 md:hidden">
    <button type="button" class="flex size-7 items-center justify-center" aria-label="Back" (click)="goBack()">
      <img src="assets/report/back-mobile.svg" width="10.3047" height="18.41" alt="" />
    </button>
    <span class="text-lg font-bold leading-7">Reports</span>
    <button
      type="button"
      class="flex size-7 items-center justify-center"
      aria-label="Download report"
      [class.invisible]="!(report$ | async)?.result"
      (click)="download()"
    >
      <img src="assets/report/download-mobile.svg" width="28" height="28" alt="" />
    </button>
  </div>

  <!-- Crumbs/Mobile - Figma node 82:34326 -->
  <div class="flex gap-2 overflow-x-auto py-4 pl-[27px] md:hidden">
    <span class="shrink-0 whitespace-nowrap rounded-full border border-[#DDB9FD] bg-[#DAD6FB] px-[10px] py-[6px] text-sm font-bold leading-[21px]">
      Breast Cancer Risk Assessment
    </span>
  </div>

  <div class="flex w-full flex-1 gap-8 px-[10px] pb-10 pt-[7px] md:px-[132px] md:pt-14">
    <!-- Menu/MyData/Desktop - Figma node 73:5781 -->
    <nav class="hidden w-[180px] shrink-0 flex-col gap-[10px] lg:flex">
      <div class="flex flex-col">
        <div class="flex items-center gap-2 rounded-lg bg-black p-3">
          <img src="assets/report/menu-health-active.svg" width="24" height="24" alt="" />
          <span class="text-base leading-normal text-white">Health</span>
        </div>
        <div class="flex items-center gap-2 border-l border-[#7000FF] px-5 py-3" aria-current="page">
          <img src="assets/report/menu-reports-active.svg" width="24" height="24" alt="" />
          <span class="text-base font-bold leading-normal">Reports</span>
        </div>
      </div>
    </nav>

    <main class="flex min-w-0 flex-1 flex-col gap-[30px]">
      <ng-container *ngIf="report$ | async as report">
        <!-- Navigation/My Data - Figma node 49:13365 -->
        <div class="hidden items-stretch gap-[10px] md:flex">
          <button
            type="button"
            class="flex w-[417px] shrink-0 items-center gap-[10px] rounded-[10.4px] bg-[#DAD6FB] px-5 py-4"
            (click)="goBack()"
          >
            <span *ngIf="report.result" class="flex size-6 items-center justify-center">
              <img src="assets/report/back.svg" width="9.1313" height="15.8789" alt="" />
            </span>
            <span class="whitespace-nowrap text-lg font-medium leading-normal">Health Reports</span>
          </button>
          <div class="flex min-w-0 flex-1 items-center justify-between gap-2 rounded-[10.4px] bg-[#DAD6FB] px-5 py-4">
            <span class="truncate text-lg font-medium leading-normal">Breast Cancer Risk Assessment</span>
            <span *ngIf="report.result" class="flex size-6 shrink-0 items-center justify-center">
              <img class="-rotate-90" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
            </span>
          </div>
          <button
            *ngIf="report.result"
            type="button"
            class="flex shrink-0 items-center rounded-[10.4px] bg-[#DAD6FB] px-5 py-4"
            aria-label="Download report"
            (click)="download()"
          >
            <img src="assets/report/download.svg" width="24" height="24" alt="" />
          </button>
        </div>

        <!-- Report - Figma nodes 40:10598 (desktop), 82:34356 (mobile) -->
        <ng-container *ngIf="report.result as result; else statusCard">
          <section class="flex flex-col gap-2 overflow-hidden rounded-[10.4px] bg-white pt-[15px] md:py-4">
            <h1 class="px-[10px] text-center text-lg uppercase leading-7 tracking-[2px] md:px-[30px]">Breast cancer risk assessment</h1>

            <p class="px-[10px] pb-[15px] pt-[5px] text-base leading-[22px] md:px-[30px] md:py-[15px] md:text-lg md:leading-7">
              Your result uses the Gail model to estimate your risk of invasive breast cancer up to age 90. It can help you and your healthcare professional discuss your breast health and next steps.
            </p>

            <div class="p-[10px] md:px-[30px]">
              <p class="rounded-[10px] bg-[#F4F2FF] p-[10px] text-center text-base leading-[22px] md:text-[22px] md:font-bold md:leading-7">
                Your estimated risk of invasive breast cancer up to age 90 is {{ result.lifetimeRisk | number: '1.0-1' }}%, compared with the model’s U.S. average of {{ result.averageRisk | number: '1.0-1' }}% for your age and race/ethnicity.
              </p>
            </div>

            <!-- Breast Cancer Risk Chart - Figma nodes 40:10615 (desktop), 86:35171 (mobile) -->
            <figure class="flex flex-col items-center gap-[10px] px-[10px] md:px-[30px] md:py-[10px]">
              <div class="w-full rounded-[10px] border border-[#DAD6FB] py-[10px] md:border-[3px] md:px-[10px] md:py-[30px]">
                <div class="mx-auto flex w-full max-w-[944px] gap-[5px] pr-3 md:gap-4 md:pr-6">
                  <div class="relative h-[127px] w-[50px] shrink-0 text-right text-[8px] font-bold leading-normal md:h-[295px] md:w-[130px] md:text-[20px] md:leading-6">
                    <span class="absolute inset-x-0 top-[32px] -translate-y-1/2 md:top-[97px]">U.S. average</span>
                    <span class="absolute inset-x-0 top-[86px] -translate-y-1/2 md:top-[179px]">Your Lifetime Risk</span>
                  </div>

                  <div class="relative h-[153px] min-w-0 flex-1 md:h-[337px]">
                    <ng-container *ngFor="let tick of chartTicks">
                      <div
                        class="absolute top-0 h-[127px] -translate-x-1/2 bg-black md:h-[295px]"
                        [ngClass]="tick === highlightedTick ? 'w-[2px]' : 'w-px'"
                        [style.left.%]="chartPosition(tick)"
                      ></div>
                      <div
                        class="absolute top-[127px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-black md:top-[295px]"
                        [ngClass]="tick === highlightedTick ? 'size-[10px]' : 'size-[5px]'"
                        [style.left.%]="chartPosition(tick)"
                      ></div>
                      <span
                        class="absolute top-[129px] -translate-x-1/2 whitespace-nowrap text-[8px] font-bold leading-6 md:top-[313px] md:text-[20px]"
                        [style.left.%]="chartPosition(tick)"
                      >{{ tick }}%</span>
                    </ng-container>
                    <div class="absolute left-0 right-0 top-[127px] h-px bg-black md:top-[295px]"></div>

                    <div
                      class="absolute left-0 top-[20px] h-[25px] rounded-r-[10px] bg-[#CABFFF] md:top-[72px] md:h-[51px]"
                      [style.width.%]="chartPosition(result.averageRisk)"
                    ></div>
                    <div
                      class="absolute left-0 top-[74px] h-[25px] rounded-r-[10px] bg-[#5D38F1] md:top-[154px] md:h-[51px]"
                      [style.width.%]="chartPosition(result.lifetimeRisk)"
                    ></div>

                    <!-- Values sit just past the bar end so they stay readable on small bars -->
                    <span
                      class="absolute top-[20px] flex h-[25px] items-center whitespace-nowrap pl-1 text-[10px] font-bold leading-6 md:top-[72px] md:h-[51px] md:pl-2 md:text-[20px]"
                      [style.left.%]="chartPosition(result.averageRisk)"
                    >{{ result.averageRisk | number: '1.1-1' }}%</span>
                    <span
                      class="absolute top-[74px] flex h-[25px] items-center whitespace-nowrap pl-1 text-[10px] font-bold leading-6 md:top-[154px] md:h-[51px] md:pl-2 md:text-[20px]"
                      [style.left.%]="chartPosition(result.lifetimeRisk)"
                    >{{ result.lifetimeRisk | number: '1.1-1' }}%</span>
                  </div>
                </div>
              </div>
              <figcaption class="text-center text-base font-bold italic capitalize leading-6 md:text-lg md:leading-7">
                Estimated invasive breast cancer risk up to age 90
              </figcaption>
            </figure>

            <div class="flex flex-col gap-[3px]">
              <div class="flex flex-col gap-[10px] px-[10px] py-[15px] md:gap-5 md:px-[30px]">
                <h2 class="text-[19px] font-bold leading-5 md:text-[22px] md:leading-7">What this result means</h2>
                <div class="space-y-3 text-base leading-[22px] md:space-y-0 md:text-lg md:leading-7">
                  <p *ngIf="result.lifetimeRisk > result.averageRisk">
                    <span class="font-bold">Your estimate is above the model’s average.</span>
                    It does not mean you have breast cancer or will develop it.
                  </p>
                  <p *ngIf="result.lifetimeRisk <= result.averageRisk">
                    <span class="font-bold">Your estimate is at or below the model’s average.</span>
                    It does not mean you cannot develop breast cancer.
                  </p>
                  <p>Use this result to start a conversation about your breast health. Your healthcare professional can help put it in context.</p>
                </div>
              </div>

              <div class="flex flex-col gap-[13px] py-[15px]">
                <div class="flex flex-col gap-[10px] px-[10px] md:gap-5 md:px-[30px]">
                  <h2 class="text-[19px] font-bold leading-5 md:text-[22px] md:leading-7">What to do next</h2>
                  <div class="space-y-3 text-base leading-[22px] md:space-y-0 md:text-lg md:leading-7">
                    <p class="font-bold">Discuss your result with a healthcare professional.</p>
                    <p>Share this report with your healthcare professional. They can review your result alongside your age, breast density, personal and family history, and help determine which screening schedule is appropriate for you.</p>
                  </div>
                </div>
                <div class="flex p-[10px] md:px-[30px]">
                  <p class="rounded-[10px] bg-[#F4F2FF] p-[10px] text-lg font-bold leading-7 md:text-[22px]">
                    Your Breast Density: {{ result.breastDensity }}
                  </p>
                </div>
              </div>

              <div class="px-[10px] md:px-[30px]">
                <p class="rounded-[10px] bg-[#F4F2FF] p-[15px] text-base leading-[22px] md:px-[30px] md:text-lg md:leading-7">
                  <span class="font-bold">Breast density is not included in your Gail estimate.</span>
                  Dense tissue can increase breast cancer risk and make cancer harder to see on a mammogram. Ask your healthcare professional whether additional screening would be helpful for you.
                </p>
              </div>

              <div class="flex flex-col gap-5 px-[10px] py-[15px] md:px-[30px]">
                <h2 class="text-[19px] font-bold leading-5 md:text-[22px] md:leading-7">Factors that may affect your screening</h2>
                <div class="space-y-3 text-base leading-[22px] md:space-y-0 md:text-lg md:leading-7">
                  <p class="font-bold">Your risk estimate is only one part of the picture.</p>
                  <p>The type and frequency of screening that may be appropriate for you can also depend on:</p>
                  <ul class="list-disc pl-5">
                    <li *ngFor="let factor of screeningFactors">{{ factor }}</li>
                  </ul>
                </div>
              </div>

              <div class="flex flex-col gap-5 px-[10px] py-[15px] md:px-[30px]">
                <h2 class="text-[19px] font-bold leading-5 md:text-[22px] md:leading-7">About this estimate</h2>
                <div class="text-base leading-[22px] md:text-lg md:leading-7">
                  <p>This report uses the Gail model to estimate invasive breast cancer risk up to age 90. It considers age, race/ethnicity, menstrual and birth history, breast biopsies, and breast cancer in your mother, sisters or daughters.</p>
                  <h3 class="my-7 text-[19px] font-bold leading-5 md:text-[20px] md:leading-7">Important limitations</h3>
                  <p class="mb-3 md:mb-0">Gail does not include breast density or extended family history. It is not suitable for people with prior breast cancer, DCIS, LCIS or a known BRCA1/2 mutation. It uses U.S. data; accuracy varies across populations.</p>
                  <p>This is an estimate, not a diagnosis. Discuss your result and screening options with a healthcare professional.</p>
                </div>
              </div>
            </div>

            <div class="flex flex-col">
              <button type="button" class="flex h-14 w-full items-center justify-between border-t border-black/10 px-[10px] py-[15px] text-left md:px-[30px]" [disabled]="openingQuiz" (click)="openQuiz(reviewSurveyPath)">
                <span class="text-base font-bold leading-6">Review your survey</span>
                <span class="flex size-6 items-center justify-center">
                  <img class="rotate-180" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
                </span>
              </button>
              <button type="button" class="flex h-14 w-full items-center justify-between border-t border-black/10 px-[10px] py-[15px] text-left md:hidden" (click)="download()">
                <span class="text-base font-bold leading-6">Download the report</span>
                <span class="flex size-6 items-center justify-center">
                  <img class="rotate-180" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
                </span>
              </button>
              <a class="flex h-14 w-full items-center justify-between border-t border-black/10 px-[10px] py-[15px] text-left md:px-[30px]" [href]="supportUrl" target="_blank" rel="noopener">
                <span class="text-base font-bold leading-6">Report an issue</span>
                <span class="flex size-6 items-center justify-center">
                  <img class="rotate-180" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
                </span>
              </a>
            </div>
          </section>

          <!-- FAQ - Figma node 40:12755 -->
          <section class="flex flex-col gap-2 overflow-hidden rounded-[10.4px] bg-white pt-[15px] md:pt-4">
            <h2 class="px-[10px] text-center text-lg uppercase leading-7 tracking-[2px] md:px-[30px]">Frequently asked questions</h2>

            <p class="px-[10px] pb-[15px] pt-[5px] text-base leading-[22px] md:px-[30px] md:py-[15px] md:text-lg md:leading-7">
              Understand what your Gail estimate includes, what it leaves out, and how to use it in a conversation with your healthcare professional.
            </p>

            <div class="flex flex-col">
              <div *ngFor="let item of faq; let i = index" class="border-t border-black/10">
                <button
                  type="button"
                  class="flex w-full items-center justify-between gap-[10px] px-[10px] py-[15px] text-left md:px-[30px]"
                  [attr.aria-expanded]="openFaq.has(i)"
                  (click)="toggleFaq(i)"
                >
                  <span class="text-base font-bold leading-6">{{ i + 1 }}. {{ item.question }}</span>
                  <span class="flex size-6 shrink-0 items-center justify-center">
                    <img
                      class="transition-transform"
                      [ngClass]="openFaq.has(i) ? 'rotate-90' : '-rotate-90'"
                      src="assets/report/chevron.svg"
                      width="9.13196"
                      height="15.8783"
                      alt=""
                    />
                  </span>
                </button>
                <div *ngIf="openFaq.has(i)" class="flex flex-col gap-3 pb-[15px] pl-[10px] pr-[44px] text-base leading-6 md:pl-[30px] md:pr-16">
                  <ng-container *ngFor="let block of item.answer">
                    <p *ngIf="block.type === 'text'">{{ block.text }}</p>
                    <a
                      *ngIf="block.type === 'link'"
                      class="block self-start underline"
                      [href]="block.href"
                      target="_blank"
                      rel="noopener"
                    >{{ block.text }}</a>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- BC Report states - Figma nodes 216:13821, 216:13230, 214:11924 -->
        <ng-template #statusCard>
          <ng-container *ngIf="statusContent[report.status] as content">
            <section class="flex flex-col gap-2 overflow-hidden rounded-[10.4px] bg-white pt-[15px] md:pt-4" [class.pb-4]="!content.showReviewSurvey && !content.showReportIssue">
              <h1 class="px-[10px] text-center text-lg uppercase leading-7 tracking-[2px] md:px-[30px]">{{ content.title }}</h1>
              <p class="px-[10px] pb-[15px] pt-[5px] text-base leading-[22px] md:px-[30px] md:py-[15px] md:text-lg md:leading-7">{{ content.body }}</p>

              <div *ngIf="content.showReviewSurvey || content.showReportIssue" class="flex flex-col">
                <button *ngIf="content.showReviewSurvey" type="button" class="flex h-14 w-full items-center justify-between border-t border-black/10 px-[10px] py-[15px] text-left md:px-[30px]" [disabled]="openingQuiz" (click)="openQuiz(reviewSurveyPath)">
                  <span class="text-base font-bold leading-6">Review your survey</span>
                  <span class="flex size-6 items-center justify-center">
                    <img class="rotate-180" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
                  </span>
                </button>
                <a *ngIf="content.showReportIssue" class="flex h-14 w-full items-center justify-between border-t border-black/10 px-[10px] py-[15px] text-left md:px-[30px]" [href]="supportUrl" target="_blank" rel="noopener">
                  <span class="text-base font-bold leading-6">Report an issue</span>
                  <span class="flex size-6 items-center justify-center">
                    <img class="rotate-180" src="assets/report/chevron.svg" width="9.13196" height="15.8783" alt="" />
                  </span>
                </a>
              </div>
            </section>

            <button
              *ngIf="content.cta as cta"
              type="button"
              class="flex w-full items-center gap-[10px] rounded-[10px] bg-[#7000FF] p-[15px] text-left disabled:opacity-70"
              [disabled]="openingQuiz"
              (click)="openQuiz(cta.quizPath)"
            >
              <span class="flex-1 text-lg font-bold leading-normal text-white">{{ cta.label }}</span>
              <span class="flex size-6 items-center justify-center">
                <img class="rotate-180" src="assets/report/chevron-white.svg" width="9.13131" height="15.8789" alt="" />
              </span>
            </button>
          </ng-container>
        </ng-template>
      </ng-container>
    </main>
  </div>

  <app-desktop-footer></app-desktop-footer>

  <!-- Footer/Mobile - Figma node 82:34181 -->
  <footer class="flex w-full flex-col gap-[38px] md:hidden">
    <div class="flex flex-col items-start gap-3 px-5 text-sm leading-[18px]">
      <a class="text-black hover:underline" href="https://legal.stringhealth.ai/privacy-policy.html" target="_blank" rel="noopener">Privacy policy</a>
      <a class="text-black hover:underline" href="https://legal.stringhealth.ai/terms-of-use.html" target="_blank" rel="noopener">Terms and Conditions</a>
      <button type="button" class="font-bold text-[#5D38F1] underline" (click)="logout()">Logout</button>
    </div>
    <div class="flex h-[55px] w-full items-start justify-between bg-white px-5 pb-[5px] pt-[15px]">
      <svg class="block h-4 w-[45px]" viewBox="0 0 69 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="IVY">
        <path d="M6.20154 24H0V0H6.20154V24Z" fill="black" />
        <path d="M25.1055 17.8392L33.3004 0H39.7677L28.1177 24H21.8276L10.2218 0H16.9106L25.1055 17.8392Z" fill="black" />
        <path d="M51.8129 13.9126L40.8716 0H48.0476L55.0908 9.51199L62.134 0H69L57.9258 13.9126V24H51.8129V13.9126Z" fill="black" />
      </svg>
      <span class="text-xs leading-[18px] text-[#8B8C91]">Health Assistant v{{ appVersion }}</span>
    </div>
  </footer>
</div>
